import { useCallback, useEffect, useState } from 'react'

import BigNumber from 'bignumber.js'
import { useWallet } from 'use-wallet'

import { getStaked, getMasterChefContract } from '../cvip/utils'
import useCvip from './useCvip'
import useBlock from './useBlock'

const useStakedBalance = (pid: number) => {
  const [balance, setBalance] = useState(new BigNumber(0))
  const { account }: { account: string } = useWallet()
  const cvip = useCvip()
  const masterChefContract = getMasterChefContract(cvip)
  const block = useBlock()

  const fetchBalance = useCallback(async () => {
    const balance = await getStaked(masterChefContract, pid, account)
    setBalance(new BigNumber(balance))
  }, [account, pid, cvip])

  useEffect(() => {
    if (account && cvip) {
      fetchBalance()
    }
  }, [account, pid, setBalance, block, cvip])

  return balance
}

export default useStakedBalance
